// // components/StorefrontHeader.jsx
// import React, { useEffect, useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { Search, ShoppingCart, X } from "lucide-react";
// import { useTheme } from "../hooks/useTheme";

// const NAV_ITEMS = [
//   { path: "/marketplace", label: "Shop" },
//   { path: "/dropshipping", label: "Ready to ship" },
//   { path: "/preorder", label: "Pre-order windows" },
// ];

// export default function StorefrontHeader({
//   title,
//   subtitle,
//   onSearch,
//   searchValue = "",
//   searchPlaceholder = "Search products…",
// }) {
//   const { colors } = useTheme();
//   const location = useLocation();
//   const [searchOpen, setSearchOpen] = useState(!!searchValue);
//   const [draft, setDraft] = useState(searchValue);

//   useEffect(() => {
//     setDraft(searchValue);
//     if (searchValue) setSearchOpen(true);
//   }, [searchValue]);

//   const submit = (e) => {
//     e.preventDefault();
//     onSearch?.(draft.trim());
//   };

//   const clear = () => {
//     setDraft("");
//     onSearch?.("");
//     setSearchOpen(false);
//   };

//   const isActive = (path) =>
//     location.pathname === path ||
//     (path !== "/" && location.pathname.startsWith(path));

//   return (
//     <header style={styles.wrap}>
//       {/* Row 1: brand + nav */}
//       <div style={styles.topRow}>
//         <Link to="/" style={styles.brandRow}>
//           <span style={styles.brandMark(colors)}>A</span>
//           <span style={styles.brandText(colors)}>Azoemart</span>
//         </Link>

//         <nav style={styles.navRow}>
//           {NAV_ITEMS.map((item) => {
//             const active = isActive(item.path);
//             return (
//               <Link
//                 key={item.path}
//                 to={item.path}
//                 style={{
//                   ...styles.navLink(colors, active),
//                 }}
//               >
//                 {item.label}
//               </Link>
//             );
//           })}
//         </nav>

//         <div style={styles.actions}>
//           {onSearch && (
//             <form onSubmit={submit} style={styles.searchForm}>
//               {!searchOpen ? (
//                 <button
//                   type="button"
//                   onClick={() => setSearchOpen(true)}
//                   aria-label="Search"
//                   style={styles.iconBtn(colors)}
//                 >
//                   <Search size={17} />
//                 </button>
//               ) : (
//                 <>
//                   <Search
//                     size={15}
//                     color={colors.secondaryText}
//                     style={styles.searchIcon}
//                   />
//                   <input
//                     autoFocus
//                     value={draft}
//                     onChange={(e) => setDraft(e.target.value)}
//                     placeholder={searchPlaceholder}
//                     style={styles.searchInput(colors)}
//                   />
//                   <button
//                     type="button"
//                     onClick={clear}
//                     aria-label="Clear"
//                     style={styles.searchClear}
//                   >
//                     <X size={13} />
//                   </button>
//                 </>
//               )}
//             </form>
//           )}

//           <Link to="/cart" aria-label="Cart" style={styles.cartBtn(colors)}>
//             <ShoppingCart size={18} />
//           </Link>
//         </div>
//       </div>

//       {/* Row 2: page title + subtitle (only when provided) */}
//       {(title || subtitle) && (
//         <div style={styles.pageHead}>
//           {title && <h1 style={styles.title(colors)}>{title}</h1>}
//           {subtitle && <p style={styles.subtitle(colors)}>{subtitle}</p>}
//         </div>
//       )}
//     </header>
//   );
// }

// const styles = {
//   wrap: {
//     marginBottom: 20,
//   },
//   topRow: {
//     display: "flex",
//     alignItems: "center",
//     gap: 24,
//     paddingBottom: 14,
//     borderBottom: "1px solid var(--border)",
//     flexWrap: "wrap",
//   },
//   brandRow: {
//     display: "inline-flex",
//     alignItems: "center",
//     gap: 8,
//     textDecoration: "none",
//     flexShrink: 0,
//   },
//   brandMark: (c) => ({
//     width: 28,
//     height: 28,
//     borderRadius: 8,
//     background: `linear-gradient(135deg, ${c.btnBg}, ${c.btnBg}cc)`,
//     color: "#fff",
//     fontWeight: 800,
//     fontSize: 14,
//     display: "inline-flex",
//     alignItems: "center",
//     justifyContent: "center",
//   }),
//   brandText: (c) => ({
//     fontSize: 15,
//     fontWeight: 800,
//     color: c.heading,
//     letterSpacing: "-0.02em",
//   }),
//   navRow: {
//     display: "flex",
//     alignItems: "center",
//     gap: 2,
//     flex: 1,
//     minWidth: 0,
//     overflowX: "auto",
//     scrollbarWidth: "none",
//   },
//   navLink: (c, active) => ({
//     padding: "7px 12px",
//     fontSize: 13.5,
//     fontWeight: active ? 700 : 600,
//     color: active ? c.heading : c.secondaryText,
//     textDecoration: "none",
//     borderRadius: 8,
//     position: "relative",
//     whiteSpace: "nowrap",
//     transition: "color 0.15s ease, background 0.15s ease",
//     background: active ? c.hoverBg : "transparent",
//   }),
//   actions: {
//     display: "flex",
//     alignItems: "center",
//     gap: 8,
//     marginLeft: "auto",
//     flexShrink: 0,
//   },
//   searchForm: { position: "relative" },
//   searchIcon: {
//     position: "absolute",
//     left: 11,
//     top: "50%",
//     transform: "translateY(-50%)",
//     pointerEvents: "none",
//   },
//   searchInput: (c) => ({
//     width: 220,
//     padding: "8px 32px 8px 34px",
//     borderRadius: 10,
//     border: `1px solid ${c.border}`,
//     background: c.raisedBg,
//     color: c.text,
//     fontSize: 13,
//     outline: "none",
//     boxSizing: "border-box",
//   }),
//   searchClear: {
//     position: "absolute",
//     right: 6,
//     top: "50%",
//     transform: "translateY(-50%)",
//     background: "none",
//     border: "none",
//     cursor: "pointer",
//     padding: 4,
//     display: "flex",
//   },
//   iconBtn: (c) => ({
//     width: 36,
//     height: 36,
//     borderRadius: 9,
//     border: `1px solid ${c.border}`,
//     background: c.raisedBg,
//     color: c.text,
//     cursor: "pointer",
//     display: "inline-flex",
//     alignItems: "center",
//     justifyContent: "center",
//   }),
//   cartBtn: (c) => ({
//     width: 36,
//     height: 36,
//     borderRadius: 9,
//     border: "none",
//     background: c.btnBg,
//     color: c.btnText,
//     display: "inline-flex",
//     alignItems: "center",
//     justifyContent: "center",
//     textDecoration: "none",
//     boxShadow: `0 2px 8px ${c.btnBg}33`,
//   }),
//   pageHead: {
//     paddingTop: 20,
//     paddingBottom: 4,
//   },
//   title: (c) => ({
//     margin: 0,
//     fontSize: "clamp(22px, 3vw, 28px)",
//     fontWeight: 800,
//     letterSpacing: "-0.02em",
//     color: c.heading,
//   }),
//   subtitle: (c) => ({
//     margin: "6px 0 0",
//     fontSize: 14,
//     color: c.secondaryText,
//     lineHeight: 1.55,
//     maxWidth: 620,
//   }),
// };
























// components/StorefrontHeader.jsx
import React, { useEffect, useState } from "react";
import { Search, X } from "lucide-react";
import { useTheme } from "../hooks/useTheme";

/**
 * Slim storefront search bar.
 *
 * No brand (already in the layout Header / Sidebar).
 * No nav (moved to StorefrontNav).
 * No page title (the nav now owns "where am I").
 *
 * Just search. Full-width on desktop, tap-to-expand on mobile.
 */
export default function StorefrontHeader({
  onSearch,
  searchValue = "",
  searchPlaceholder = "Search products…",
}) {
  const { colors } = useTheme();
  const [open, setOpen] = useState(!!searchValue);
  const [draft, setDraft] = useState(searchValue);

  // Keep the input in sync when the URL changes externally
  // (e.g. user taps a nav link that clears the search).
  useEffect(() => {
    setDraft(searchValue);
    if (searchValue) setOpen(true);
  }, [searchValue]);

  const submit = (e) => {
    e.preventDefault();
    onSearch?.(draft.trim());
  };

  const clear = () => {
    setDraft("");
    onSearch?.("");
    setOpen(false);
  };

  return (
    <header style={styles.wrap}>
      <form onSubmit={submit} style={styles.form} className="sf-search">
        {/* Mobile: show icon; tapping opens the input */}
        {!open && (
          <button
            type="button"
            onClick={() => setOpen(true)}
            aria-label="Open search"
            className="sf-search-trigger"
            style={styles.trigger(colors)}
          >
            <Search size={18} />
            <span style={styles.triggerLabel(colors)}>Search</span>
          </button>
        )}

        {open && (
          <div style={styles.inputWrap(colors)} className="sf-search-input">
            <Search
              size={15}
              color={colors.secondaryText}
              style={{ flexShrink: 0 }}
            />
            <input
              autoFocus
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              placeholder={searchPlaceholder}
              style={styles.input(colors)}
            />
            <button
              type="button"
              onClick={clear}
              aria-label="Clear search"
              style={styles.clear}
            >
              <X size={14} />
            </button>
          </div>
        )}
      </form>

      <style>{`
        /* Desktop: input always visible, no trigger */
        @media (min-width: 720px) {
          .sf-search { flex: 1; max-width: 560px; margin: 0 auto; }
          .sf-search-trigger { display: none !important; }
        }
        /* Mobile: trigger visible when input is closed */
        @media (max-width: 719px) {
          .sf-search-input { width: 100%; }
        }
      `}</style>
    </header>
  );
}

/* ══════════════════════════════════════════════════════════
   Styles
   ══════════════════════════════════════════════════════════ */

const styles = {
  wrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 14,
  },
  form: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  trigger: (c) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    width: "100%",
    padding: "11px 14px",
    borderRadius: 12,
    border: `1px solid ${c.border}`,
    background: c.raisedBg,
    color: c.secondaryText,
    fontSize: 13.5,
    fontWeight: 500,
    cursor: "pointer",
    fontFamily: "inherit",
    textAlign: "left",
  }),
  triggerLabel: (c) => ({
    color: c.secondaryText,
  }),
  inputWrap: (c) => ({
    display: "flex",
    alignItems: "center",
    gap: 10,
    width: "100%",
    padding: "0 12px",
    borderRadius: 12,
    border: `1px solid ${c.btnBg}`,
    background: c.raisedBg,
    boxShadow: `0 0 0 3px ${c.btnBg}22`,
    height: 42,
  }),
  input: (c) => ({
    flex: 1,
    minWidth: 0,
    border: "none",
    background: "transparent",
    color: c.text,
    fontSize: 14,
    outline: "none",
    fontFamily: "inherit",
  }),
  clear: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    padding: 4,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
};